import { render, staticRenderFns } from "./CommodityCollectionScrollItem.vue?vue&type=template&id=c6c463d4&scoped=true&"
import script from "./CommodityCollectionScrollItem.vue?vue&type=script&lang=ts&"
export * from "./CommodityCollectionScrollItem.vue?vue&type=script&lang=ts&"
import style0 from "./CommodityCollectionScrollItem.vue?vue&type=style&index=0&id=c6c463d4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6c463d4",
  null
  
)

export default component.exports